// utils/getLanguageBasedCountryCode.js
const supportedLanguages = ['en', 'it', 'es', 'de', 'fr'];

export default function getLanguageBasedCountryCode() {
    const userLang = (navigator.language || navigator.userLanguage).slice(0, 2);
    return supportedLanguages.includes(userLang) ? userLang : 'en';
}